import { createFileRoute } from "@tanstack/react-router";

import { CustomerSearchPage } from "@/features/customers/pages/customer-search-page";

export const Route = createFileRoute("/_authenticated/customers/search")({
  component: CustomerSearchPage,
});
